import { getAuthContext } from '../context/AuthContext';

const getAxios = () => getAuthContext().axiosInstance;

const resolveEmpresaId = async () => {
    const { user } = getAuthContext();

    if (user?.idEmpresa) {
        return user.idEmpresa;
    }

    if (user?.idSucursal) {
        const sucursalResponse = await getAxios().get(`/api/sucursales/${user.idSucursal}`);
        return sucursalResponse.data?.data?.idEmpresa ?? 1;
    }

    return 1;
};

export const ClienteService = {
    getAll: async () => {
        const idEmpresa = await resolveEmpresaId();
        const response = await getAxios().get(`/api/clientes/empresa/${idEmpresa}`);
        return response.data;
    },
    
    getById: async (id) => {
        const response = await getAxios().get(`/api/clientes/${id}`);
        return response.data;
    },
    
    getByDocumento: async (documento) => {
        const response = await getAxios().get(`/api/clientes/documento/${documento}`);
        return response.data;
    },

    create: async (cliente) => {
        const response = await getAxios().post('/api/clientes', cliente);
        return response.data;
    },

    update: async (id, cliente) => {
        const response = await getAxios().put(`/api/clientes/${id}`, cliente);
        return response.data;
    },

    delete: async (id) => {
        const response = await getAxios().delete(`/api/clientes/${id}`);
        return response.data;
    }
};
